export const en = {
  stats: [
    { value: "6+", labelLine1: "years building", labelLine2: "back-end systems" },
    { value: "MSc", labelLine1: "Computer Science", labelLine2: "UFBA" },
    { value: "5", labelLine1: "companies", labelLine2: "contributed to" },
  ],
};
